import styled, { css } from 'styled-components';

export const Container = styled.div`
  background: #0f0f0f;

  display: flex;
  overflow: hidden;

  flex: 1;
  width: 100%;
  height: 100%;
`;

export const Wrapper = styled.div`
  overflow: auto;
  width: 100%;
`;

export const PageHeader = styled.div`
  min-height: 10.6rem;
  width: 100%;

  background: #242424;

  padding: 0 5.6rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 1024px) {
    padding: 0 4rem;
  }

  @media (max-width: 425px) {
    padding: 0 2rem;
  }
`;

export const PageHeaderBackButton = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 25px;
  align-items: center;
  justify-content: center;
  color: #ffdf22;
  cursor: pointer;
`;

export const PageHeaderBackButtonLabel = styled.div`
  font-weight: bold;
  padding-left: 5px;
  text-transform: uppercase;

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const Sidebar = styled.div`
  width: 10rem;
  height: 100%;

  border-right: 1px solid #cfcfcf;

  > ul {
    > li {
      display: flex;
      align-items: center;

      height: 5.2rem;
      padding-left: 1rem;

      cursor: pointer;
      transition: ${({ theme }) => theme.transition.default};

      > p {
        font-size: 1.6rem;
        line-height: 3.5rem;
        color: #ffffff;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      :hover {
        background: #242424;
      }

      &.active {
        background: #242424;
        border-right: 4px solid #ffd503;

        > p {
          font-weight: bold;
          color: #ffdf22;
        }
      }

      @media (min-width: 768px) {
        padding-left: 3.2rem;

        > p {
          font-size: 1.9rem;
        }
      }
    }
  }

  @media (min-width: 768px) {
    width: 27rem;
  }
`;

export const PageHeaderSaveButton = styled.button`
  font-weight: bold;
  font-size: 18px;

  width: 31.7rem;
  height: 4.4rem;

  background: transparent linear-gradient(97deg, #ffdf22 0%, #ffd503 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 50px;

  @media (max-width: 768px) {
    width: 100%;
  }

  &:hover {
    opacity: 0.85;
    transition: 0.3s;
  }
`;

export const FormContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2.9rem 4.4rem;

  width: 68.4rem;

  margin-bottom: 2.9rem;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    width: 100%;
  }
`;

type HideFormProps = {
  hide?: boolean;
};

export const HideForm = styled.div<HideFormProps>`
  ${({ hide }) =>
    hide &&
    css`
      display: none;
    `}
`;

export const FormLineWrapper = styled.div`
  width: 68.4rem;
  @media (max-width: 1024px) {
    width: 32rem;
  }
  @media (max-width: 425px) {
    width: 100%;
  }
`;

export const FieldSet = styled.fieldset`
  border: none;
  width: 38rem;

  @media (max-width: 1250px) {
    margin-right: 0rem;
  }

  @media (max-width: 425px) {
    width: 100%;
  }
`;

export const Label = styled.label`
  margin: 0 1.7rem;
  padding-bottom: 0.5rem;

  font-size: 1.5rem;
  font-weight: bold;
  color: #fff;
`;

export const CheckboxWrapper = styled.div`
  margin-top: 1.4rem;
`;

interface SectionLabelProps {
  secondary?: boolean;
}

export const SectionLabel = styled.h1<SectionLabelProps>`
  margin-bottom: 3.1rem;

  font-size: 1.8rem;
  text-transform: uppercase;
  color: #ffdf22;

  ${(props) =>
    props.secondary &&
    css`
      margin-top: 5.8rem;
    `}

  @media (max-width: 1250px) {
    display: flex;
    justify-content: center;
  }
`;

export const DoubleInputContainer = styled.div`
  display: flex;
  justify-content: space-between;

  * {
    /* width: 15.4rem; */
    width: 18rem;

    @media (max-width: 425px) {
      width: 48%;
    }
  }
`;

export const SelectWrapper = styled.div`
  margin-top: 0.5rem;

  div {
    border-radius: 2rem;
  }
`;

type RadioButtonProps = {
  isSelected?: boolean;
};

export const RadioButton = styled.button.attrs({
  type: 'button',
})<RadioButtonProps>`
  padding: 0 2rem;
  margin-bottom: 0.7rem;
  background: transparent;

  display: flex;

  align-items: center;

  .radio {
    width: 2.2rem;
    height: 2.2rem;
    background: #000;

    border: 1px solid #fff;
    border-radius: 0.4rem;
  }

  .filled {
    width: 100%;
    height: 100%;
    border: 1px solid #000;
    border-radius: 0.4rem;

    background: ${({ isSelected }) => (isSelected ? '#fff' : false)};
  }

  p {
    color: #fff;

    font-size: 1.5rem;
    padding: 0 0.5rem;
    text-transform: capitalize;
  }

  :active {
    filter: opacity(0.5);
  }
`;

export const ProfileCodeContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 1024px) {
    width: 32rem;
  }

  @media (max-width: 425px) {
    width: 100%;
  }

  input {
    text-align: center;
  }
`;

export const TextareaSet = styled.fieldset`
  border: none;
  width: 68.4rem;
  margin-bottom: 2.5rem;

  @media (max-width: 1024px) {
    width: 32rem;
  }

  @media (max-width: 425px) {
    width: 100%;
  }
`;

export const SessionContainer = styled.section`
  margin: 3.6rem 5.3rem;

  @media (max-width: 425px) {
    margin: 2rem;
  }
`;
